<template>
  <main class="page-companies-show py-5">
    <div class="container">
      <div class="row no-gutters" v-if="company">
        <div class="col-12 pb-3 mb-5">
          <FormContainer @submitForm="editCompany">
            <div class="container-fluid">
              <div class="row">
                <FormInputTextWidget
                  class="col-12 col-md-6 col-lg-8"
                  label="Ragione Sociale"
                  v-if="isAdmin"
                  v-model="company.name"
                  :errorMsg="errorHash.name"
                  @input="removeError('name')"
                />

                <FormInputTextWidget
                  class="col-12 col-md-6 col-lg-4"
                  label="Partita IVA"
                  v-model="company.vat"
                  :errorMsg="errorHash.vat"
                  @input="removeError('vat')"
                />

                <FormInputSelectWidget
                  class="col-12"
                  label="Consulente"
                  v-model="currentConsultant"
                  v-if="isAdmin && consultants.length"
                  :options="consultantOptions"
                  not-required
                  optionValue="id"
                  placeholder="Seleziona un consulente"
                />

                <div class="col-12">
                  <div class="row pt-4">
                    <div class="col-auto">
                      <router-link class="btn btn-outline-primary" :to="{ name: 'companies-show', params: { id: $route.params.id } }">Torna all'azienda</router-link>
                    </div>
                    <div class="col-auto">
                      <button class="btn btn-primary">Salva</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FormContainer>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import $api from '@/libs/Api/services/api.js';
import $oauth2 from '@/libs/OAuth2/services/auth.js';
import validateMixin from '@/libs/Form/mixins/validate.js';

export default {
  name: 'page-companies-show',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer.vue'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget.vue'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget.vue'),
  },
  data () {
    return {
      company: null,
      consultants: null,
      currentConsultant: null,
    };
  },
  computed: {
    isAdmin () {
      return !!this?.$oauth2?.me?.admin;
    },
    isConsultant () {
      return !!this?.$oauth2?.me?.consultant;
    },
    consultantOptions () {
      return (this.consultants || []).map(c => ({ ...c, label: `${c.name} ${c.surname}` }));
    },
  },
  methods: {
    editCompany () {
      const body = {
        vat: this.company.vat,
      };

      if (this.isAdmin) {
        Object.assign(body, {
          name: this.company.name,
          consultant: this.currentConsultant,
        });
      }

      this.$api.updateCompany(this.$route.params.id, body).then(res => {
        this.$log.debug(res.data);
      }).catch(this.$log.error);
    },
  },
  async beforeRouteEnter (to, from, next) {
    const admin = !!$oauth2?.me?.admin;

    try {
      const [
        companyResponse,
        consultantsResponse,
      ] = await Promise.all([
        $api.company(to.params.id),
        admin ? $api.consultants() : Promise.resolve(null),
      ]);

      return next((vm) => {
        vm.company = companyResponse?.data || null;
        vm.consultants = consultantsResponse?.data?.consultants || null;
        vm.currentConsultant = vm.company.consultant.id;
      });
    } catch (error) {
      return next((vm) => vm.$log.error(error));
    }
  },
};

</script>
